import React from 'react';
import { useAuth } from '../../../contexts/AuthProvider';
import { buildLoginUrl } from '../../../utils/authHelper';
import Max from '../MyAccount/component/Max/Max';
import '../MyAccount/css/max.scss';

/**
 * Standalone HBO Max page wrapper
 * Handles client-side auth via AuthProvider,
 * then passes user data as props to Max component.
 */
const HboMaxPage: React.FC = () => {
  const { ready, userData, authVerified, isLoggedIn } = useAuth();

  const currentLang: 'en' | 'zh' = userData?.currentLang === 'zh' ? 'zh' : 'en';
  const loginUrl = buildLoginUrl(currentLang);

  // If we're not ready at all, or if we are logged in but haven't finished 
  // verifying the full profile (authVerified), show a loading state or nothing.
  if (!ready || (isLoggedIn && !authVerified)) {
    return (
      <div className="page-wrapper stb-max-page-wrapper">
        <div className="container">
          <div className="loading-wrapper show inline">
            <div className="spinner-border" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <Max
      currentLang={currentLang}
      nowSessionId={userData?.nowSessionId}
      loginUrl={loginUrl}
      fsaType={userData?.fsaType}
      fsa={userData?.fsa}
      cust_type={userData?.cust_type}
      mobilenowid={userData?.mobile}
      emailnowid={userData?.email}
      nickname={userData?.nickname}
      novaXIndicator={userData?.novaXIndicator}
      verifiedDate={userData?.verifiedDate}
    />
  );
};

export default HboMaxPage;
